import { Injectable, signal } from '@angular/core';
import { OrderCappingToast } from '../models/order.model';
import * as _ from 'underscore';

@Injectable({
  providedIn: 'root'
})
export class OrderCappingToastService {
  private readonly toasts = signal<OrderCappingToast[]>([]);
  readonly allToasts = this.toasts.asReadonly();

  show(toast: OrderCappingToast): void {
    this.toasts.update((toasts) =>
      !toasts.some(t => _.isEqual(t.template, toast.template)) ? [...toasts, toast] : [...toasts]
    );
  }

  remove(toast: OrderCappingToast): void {
    this.toasts.update((toasts) => toasts.filter((t) => !_.isEqual(t.template, toast.template)));
  }

  clear(): void {
    this.toasts.set([]);
  }
}
